import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export interface IConfirmationDialog {
    DialogHeaderText: string
    DialogBodyText: any
    openDialog: boolean
    handleComfirm: () => void
    handleClose: () => void
    confirmtext?: string
    cancelText?: string
}

const ConfirmationDialog = (props: IConfirmationDialog): ReactElement => {
    const { t } = useTranslation()
    const {
        openDialog,
        handleComfirm,
        handleClose,
        DialogHeaderText,
        DialogBodyText,
        confirmtext,
        cancelText,
    } = props
    return (
        <div>
            <Dialog
                open={openDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                aria-label={DialogHeaderText}
                sx={{
                    Padding: '10px',
                }}
            >
                <Box sx={{ padding: '10px 0px' }}>
                    <DialogTitle id="alert-dialog-title">
                        {DialogHeaderText}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {DialogBodyText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{ padding: '10px 24px' }}>
                        <Button
                            onClick={handleClose}
                            id={`${cancelText || 'cancel'}`}
                            title={cancelText ? cancelText : t('cancel')}
                        >
                            {cancelText ? cancelText : t('cancel')}
                        </Button>
                        <Button
                            id={`${confirmtext || 'delete'}`}
                            onClick={() => handleComfirm()}
                            autoFocus
                            title={confirmtext ? confirmtext : t('Delete')}
                        >
                            {confirmtext ? confirmtext : t('Delete')}
                        </Button>
                    </DialogActions>
                </Box>
            </Dialog>
        </div>
    )
}

export default ConfirmationDialog
